import _ from 'lodash';
import { PricesState } from '../../../routes/reducers/types';
import {
  FETCH_PRICES_REQUEST,
  FETCH_PRICES_SUCCESS,
  FETCH_PRICES_FAILURE,
  INVALIDATE_PRICES,
} from '../actions/types';
import type { PriceActions } from '../actions/types';

const initialState: PricesState = {
  loading: [],
};

export default (state: PricesState = initialState, action: PriceActions): PricesState => {
  switch (action.type) {
    case FETCH_PRICES_REQUEST:
      return {
        ...state,
        loading: [...state.loading, ...action.loading],
      };
    case FETCH_PRICES_FAILURE: {
      const stateWithoutIds = _.omit(state, action.accIds);
      const loading = _.difference(state.loading, action.loading);
      return {
        ...stateWithoutIds,
        loading,
      };
    }
    case FETCH_PRICES_SUCCESS: {
      const stateWithoutIds = _.omit(state, action.accIds);
      const loading = _.difference(state.loading, action.loading);
      return {
        ...stateWithoutIds,
        ...action.prices,
        loading,
      };
    }
    case INVALIDATE_PRICES: {
      return _.omit(state, action.accIds);
    }
    default:
      return state;
  }
};
